<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTableFw',title:'销售样表（服务订单）'},{title:'新增销售样表'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                                 class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>新增销售样表</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine fwyb">
                                            <el-form-item label="产品编码" class="h-elformWrap-2" prop="prodcode">
                                                <el-input placeholder="请输入" v-model="f.prodcode" @change="selectModel"></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2" prop="promodel">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.promodel" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2" prop="prodseries">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.prodseries" readonly></el-input>
                                            </el-form-item>


                                         <!--   <el-form-item label="状态" class="h-elformWrap-2" prop="prodstatus">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"
                                                          :clearable="true"/>
                                            </el-form-item>-->
                                            <el-form-item label="类型" class="h-elformWrap-2" prop="genre">
                                                <brselect category="sl_genre" v-model="f.genre" :v="f.genre"></brselect>
                                            </el-form-item>
                                            <el-form-item label="公司名称" class="h-elformWrap-2" prop="companycode">
                                                <brselect category="xsyb_gongsi" :v="f.companycode" v-model="f.companycode"/>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2" prop="factory">
                                                <desselect category="factory" :des="this.factoryDict" :v="f.factory" clearable v-model="f.factory"/>
                                            </el-form-item>

                                            <el-form-item label="是否有标准价" class="h-elformWrap-2" prop="havePrice">
                                                <brselect category="permit" v-model="f.havePrice" :v="f.havePrice"></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入销额" class="h-elformWrap-2" prop="xiaoe">
                                                <brselect  category="xiaoe_jishu" :v="f.xiaoe" v-model="f.xiaoe"></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入基数" class="h-elformWrap-2" prop="jishu">
                                                <brselect category="xiaoe_jishu" :v="f.jishu" v-model="f.jishu"></brselect>
                                            </el-form-item>
                                            <el-form-item label="链群" class="h-elformWrap-2" prop="lianqun">
                                                <brselectlazy category="xsyb_lianqun" v-model="f.lianqun"
                                                              :v="f.lianqun"></brselectlazy>
                                            </el-form-item>
                                            <el-form-item label="子链群" class="h-elformWrap-2" prop="lianqunchild">
                                                <brselect category="xsyb_lianqunchild" v-model="f.lianqunchild" :clearable="true"
                                                          :v="f.lianqunchild"></brselect>

                                            </el-form-item>
                                          <el-form-item label="是否增值服务" class="h-elformWrap-2" prop="isValueAddedService">
                                            <el-select v-model="f.isValueAddedService" :v="f.isValueAddedService" placeholder="请选择">
                                              <el-option v-for="(item) in fwList"
                                                         :key="item.code"
                                                         :label="item.name"
                                                         :value="item.code">
                                              </el-option>
                                            </el-select>
                                          </el-form-item>
                                        </div>
                                        <h6 style="color: red;">非1ND60产品请勿选择产地！</h6>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveS">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                //带线表单
                f: {
                    procategory: '',
                    isValueAddedService:0,
                },
                LevelName: [],
                ProCategory: [],
                rules: {
                    prodcode: [{required: true, message: '请填写产品编码', trigger: 'blur'}],
                    /*prodstatus: [{required: true, message: '请选择状态', trigger: 'change'}],*/
                    genre: [{required: true, message: '请选择类型', trigger: 'change'}],
                    companycode: [{required: true, message: '请选择公司名称', trigger: 'change'}],
                    havePrice: [{required: true, message: '请选择是否有基准价', trigger: 'change'}],
                    xiaoe: [{required: true, message: '请选择是否计算销额', trigger: 'change'}],
                    jishu: [{required: true, message: '请选择是否计算返利基数', trigger: 'change'}],
                    lianqun: [{required: true, message: '请选择链群', trigger: 'change'}],
                },
                queryq: {
                    oneLid: '',
                    materialCode:'',
                },
                factoryDict:'1N60',
                fwList:[
                  {code:1,name:"是"},
                  {code:0,name:"否"}
                ],
            }
        },
        created() {
            this.showLevelName();
        },
        methods: {
            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
            //返回
            backS() {
                this.$router.push({path: "/chanp/salesTableFw"});
            },
            //保存
            saveS() {
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    this.$msg.confirm("确认提交该销售样表?", () => {
                        for (var i = 0; i < this.LevelName.length; i++) {
                            if (this.LevelName[i].id == this.f.prodseries) {
                                this.f.oneLid = this.LevelName[i].id;
                                this.f.prodseries = this.LevelName[i].levelname;
                            }
                        }
                        ss.salesListFw.saveS(this.f).then(rd => {
                            this.$router.push({path: "/chanp/salesTableFw"});
                        })
                    });
                }
            },
            selectModel(code) {
                this.f = { "prodcode": code};
                this.$refs.f.resetFields();
                this.selectListByCode(code)

            },
            //根据根据编码查询物料信息
            selectListByCode(code) {
                this.queryq.materialCode = code;
                this.queryq.fromType = 'fw';
                ss.chanpin.selectListByCode(this.queryq).then(rd => {
                    if(rd){
                        this.f.promodel = rd.materialDescrition;
                        for (var i = 0; i < this.LevelName.length; i++) {
                            if (rd.productHierarchy.startsWith(this.LevelName[i].id)){
                                this.f.oneLid = this.LevelName[i].id;
                                this.f.prodseries = this.LevelName[i].levelname;
                            }
                        }
                    }else{
                        this.$msg.msge("物料编码错误！");
                        this.f.promodel = '';
                        this.f.oneLid ='';
                        this.f.prodseries ='';
                    }
                    this.$forceUpdate();
                })


            },





        }
    }
</script>
<style>
    .fwyb .el-form-item__label {
        width: 36%;
        text-align: right;
    }

    .fwyb .el-form-item__content {
        width: 64%;
    }

    .fwyb .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }

    .fwyb .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .fwyb .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .fwyb .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }

    .fwyb.el-form-item__content .el-select {
        width: 100%;
    }
</style>
